import * as React from 'react';
import AuthContext from 'Context/AuthContext';
import CheckoutForm from '../CheckoutForm';

export interface Props {
  children?: React.ReactNode;
}

export interface State { }

export default class UserDataWrapper extends React.Component<Props, State> {
  static contextType = AuthContext;
  context!: React.ContextType<typeof AuthContext>;
  constructor(props: Props) {
    super(props);

    this.state = {};
  }

  render() {

    const children = React.cloneElement(this.props.children as any, { user: this.context.data });

    return <>{children}</>;
  }
}
